function getUTMFromUrl() {
  const url_string = window.location.href;
  const url = new URL(url_string);
  const utm_id = url.searchParams.get('utm_id');
  const utm_source = url.searchParams.get('utm_source');
  const utm_medium = url.searchParams.get('utm_medium');
  const utm_campaign = url.searchParams.get('utm_campaign');
  const utm_term = url.searchParams.get('utm_term');
  const utm_content = url.searchParams.get('utm_content');
  const ref = url.searchParams.get('ref');
  let utmParameters = {};
  let hasUtm = false;

  if (!utm_id && !utm_source && !utm_medium && !utm_campaign && !ref && !utm_term && !utm_content) {
    return null;
  }

  if (utm_id) {
    utmParameters.utm_id = utm_id;
    hasUtm = true;
  }
  if (utm_source) {
    utmParameters.utm_source = utm_source;
    hasUtm = true;
  }
  if (utm_medium) {
    utmParameters.utm_medium = utm_medium;
    hasUtm = true;
  }
  if (utm_campaign) {
    utmParameters.utm_campaign = utm_campaign;
    hasUtm = true;
  }
  if (utm_term) {
    utmParameters.utm_term = utm_term;
    hasUtm = true;
  }
  if (utm_content) {
    utmParameters.utm_content = utm_content;
    hasUtm = true;
  }
  if (ref) {
    utmParameters.ref = ref;
  }

  return hasUtm ? utmParameters : null;
}

function saveUtmParameters() {
  const utmParams = getUTMFromUrl();
  const cartAttributes = window.shopCart?.cartAttributes || {};
  const cartAttributesHasUtm = cartAttributes ? Object.keys(cartAttributes).some(key => key.startsWith('utm_')) : null;
  let shopifyReferrer = localStorage.getItem('shopify_referrer') || null;
  if (document.referrer && document.referrer !== '') {
    let url = location.hostname;
    let cleanedUrl = url.replace(/^www\./, '');
    cleanedUrl = cleanedUrl.replace(/\.(com|org|net|io|co|biz|info|us|ca|uk|gov|edu)$/, '');
    if (!document.referrer.includes(cleanedUrl)) {
      shopifyReferrer = document.referrer;
      localStorage.setItem('shopify_referrer', shopifyReferrer);
    }
  }

  if (window.shopSettings.environment !== 'prod') {
    console.log('cartAttributes', cartAttributes);
    console.log('cartAttributesHasUtm', cartAttributesHasUtm);
    console.log('utmParams', utmParams);
    console.log('shopifyReferrer', shopifyReferrer);
  }

  if (utmParams) {
    const analyticsSessionId = localStorage.getItem('analytics_session_id') || '';
    if (window.shopSettings.environment !== 'prod') {
      console.log('analyticsSessionId', analyticsSessionId);
    }
    if (cartAttributes && cartAttributesHasUtm && analyticsSessionId === cartAttributes.analytics_session_id) {
      return;
    }

    const newAttributes = {
      ...utmParams,
      analytics_session_id: analyticsSessionId,
      referrer: shopifyReferrer
    };

    fetch(window.Shopify.routes.root + 'cart/update.js', {
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify({
        attributes: {
          ...newAttributes
        }
      })
    })
      .then(response => response.json())
      .then(data => {
        return data;
      })
      .catch(error => {
        console.error('Failed to update cart attributes:', error);
      });
  }
}
saveUtmParameters();
